/**
 * 按地域分布统计
 * 创建时间：2017-11-14
 * 创建人：baixx
 */
<template>
<div class="wrapper-content fadeInRight animated tabBox" id="district-spread-list">
    <div class="row ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		<!--表单查询开始-->
		<div class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-1 control-label">救援公司</label>
				<div class="col-sm-2">
           <multi-select-tree
            ref="ztree"
            :setting="setting"
            :isCheckAll=true
            url="/rescue-api/account/customer/fleet/"
            v-model="selectCompanysArr"
            v-on:onsuccess="onsuccess"
					></multi-select-tree>
		    </div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button type="button" class="btn btn-primary" @click="searchInfo">开始统计</button>
					<button type="button" class="btn btn-primary"  @click="resetQueryParams">重置</button>
				</div>
			</div>
			<div class="hr-line-dashed"></div>
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button type="button" @click="exportDistrictSpread" class="btn btn-primary">导出</button>
				</div>
			</div>
		</div>
		<!--表单查询结束-->
		<!--表格开始-->
		<div style="width:100%;" v-show="districtArr.length>0">
            <div class="t_left">
                <div class="cl_freeze" id="cl_freeze">
                    <table class="table table-striped table-bordered">
	                    <thead>
	                    	<tr>
								<th style="height:70px;">地域名称</th>
							</tr>
						</thead>
	                    <tbody>
	                        <tr v-for="(fileInfo,index) in districtArr" v-bind:key="index">
								<td>{{fileInfo}}</td>
							</tr>
						</tbody>
                    </table>
                </div>
            </div>
            <div class="t_r">
                <!--<div class="t_r_content" id="t_r_content" onscroll="aa()">-->
                <div class="t_r_content" id="t_r_content">
                    <table frame=hsides id='districtSpread' class="table table-striped">
                    	<thead>
	                    	<tr bgcolor="#F5F5F6">
								<th v-for="day in rescueCompanyArr" class="text-center" colspan="5">{{day}}</th>
							</tr>
							<tr>
								<template v-for="day in rescueCompanyArr">
									<th bgcolor="#FFFDE8">拖车</th>
									<th bgcolor="#FFFDE8">路修车</th>
									<th >拖车</th>
									<th >搭电</th>
									<th >换胎</th>
								</template>
							</tr>
						</thead>
                        <tbody>
                        	<tr v-for="drive in vehiclesArr">
                        		<template v-for="info in drive">
                        			<td bgcolor="#FFFDE8">{{info.vehicleTrail}}</td>
									<td bgcolor="#FFFDE8">{{info.vehicleRepair}}</td>
									<td >{{info.trailer}}</td>
									<td >{{info.takeElectricity}}</td>
									<td >{{info.changeTire}}</td>
                        		</template>
                        	</tr>
						</tbody>
                    </table>
                </div>
            </div>
            <div class="t_r_total">
                <div class="t_r_content" id="t_r_content">
                    <table class="table table-striped">
                    	<thead>
	                    	<tr bgcolor="#F5F5F6">
								<th class="text-center" colspan="5">合计</th>
							</tr>
							<tr>
								<th bgcolor="#FFFDE8">拖车</th>
								<th bgcolor="#FFFDE8">路修车</th>
								<th>拖车</th>
								<th>搭电</th>
								<th>换胎</th>
							</tr>
						</thead>
                        <tbody>
	                        <tr v-for="(fileInfo,index) in totalArr" v-bind:key="index">
								<td bgcolor="#FFFDE8">{{fileInfo.vehicleTrail}}</td>
								<td bgcolor="#FFFDE8">{{fileInfo.vehicleRepair}}</td>
								<td>{{fileInfo.trailer}}</td>
								<td>{{fileInfo.takeElectricity}}</td>
								<td>{{fileInfo.changeTire}}</td>
							</tr>
						</tbody>
                    </table>
                </div>
            </div>
        </div>
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</div>
</template>
<script>
	import Pagination from 'components/common/Pagination'
	import { OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
  import MultiSelectTree from 'components/common/MultiSelectTree'
	export default {
		name: "PageDistrictSpreadList",
		components: {
			Pagination,
			TabModal,
      MultiSelectTree
		},
		data() {
			return {
				loadingstatus:false,
				messageStr: "",					//弹出框内容
				scrollTop: '',
				queryParam:{
					customerIds: "",	        //救援公司id
				},
			    districtArr:[],                 //地域名称
			    vehiclesArr:[],
			    rescueCompanyArr:[],
			    totalArr:[],                    //合计
			    companysArr:[],                 //救援公司
			    selectCompanysArr:[],           //已选救援公司
			    isRequest:true,
			    setting: {
					data: {
						simpleData: {
							enable: true,
							pIdKey: "parentId"
						}
					},
					check: {
            enable: true,
            chkboxType : { "Y" : "", "N" : "" }
          },
					view: {
						dblClickExpand: false,
						selectedMulti: true,
						autoCancelSelected: true
					},
					callback: {
						onCheck: this.onClickSelectName
					}
				},
			};
		},
		beforeMount() {
			//this.getTableInfo();
		},
		methods: {
      //获取救援公司成功回调
			onsuccess(){
				this.getTableInfo();
			},
			//查询方法
			searchInfo(){
				this.getTableInfo();
			},
			// 获取列表信息
			getTableInfo() {
				if(this.selectCompanysArr.length ==0){
					this.openModalMsg("救援公司不能为空");
					return;
				}
				this.queryParam.customerIds = this.selectCompanysArr.join(',');
				this.loadingstatus = true;
				//this.$http.get('../../static/disticsList.json')
				this.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue-api/report/statistics/vehicle/count', {params: this.queryParam})
					.then( res => {
						if(res.body.success){
							if(res.body.data.total.length == 0){
								this.loadingstatus = false;
								this.openModalMsg("所选查询条件暂无统计结果！");
								return;
							}
							this.districtArr = [];
							this.vehiclesArr = [];
							for(var key in res.body.data.vehicles){
							    this.districtArr.push(key)
							    this.vehiclesArr.push(res.body.data.vehicles[key])
							}
							this.rescueCompanyArr = [];
							this.vehiclesArr[0].map(item=>{
								this.rescueCompanyArr.push(item.customerName)
							})
							this.totalArr = res.body.data.total;
							var ddd=document.getElementById("districtSpread");
							if(this.rescueCompanyArr.length>0 &&this.rescueCompanyArr.length<5){
								ddd.style.cssText='min-width: 1000px;';
							}
							if(this.rescueCompanyArr.length>=5 && this.rescueCompanyArr.length<10){
								ddd.style.cssText='min-width: 2200px;';
							}
							if(this.rescueCompanyArr.length>=10 && this.rescueCompanyArr.length<15){
								ddd.style.cssText='min-width: 4200px;';
							}
							if(this.rescueCompanyArr.length>=15){
								ddd.style.cssText='min-width: 6500px;';
              }
              if(this.rescueCompanyArr.length>=30){
                main.style.cssText='min-width: 20000px;';
              }
						} else {
							this.openModalMsg(res.body.message);
						}
						this.loadingstatus = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus = false;
				})
			},
			//导出
			exportDistrictSpread(){
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/report/statistics/vehicle/export',{params: this.queryParam})
					.then((res)=>{
					if(res.body.success){
						let str = res.body.data;
					//	var path = "http://192.168.1.161:8888/api";
						var path = process.env.EXPORT_PATH;
					    var api = process.env.API_ROOT;
						var fileName = path + api + '/noauth/export?url=' + str + '&path=' + this.$store.state.user.userId;
		    			var elemIF = document.createElement("iframe");
				      	elemIF.src = fileName;
				        elemIF.style.display = "none";
				        document.body.appendChild(elemIF);
					}else{
						this.openModalMsg(res.body.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.loadingstatus = false;
					this.openModalMsg(res.body.message);
				}).catch( res => {
					this.loadingstatus = false;
					this.openModalMsg("请求异常");
				})
			},
			//重置信息
			resetQueryParams:function(){
				this.isRequest = false;
				this.queryParam = {
					customerIds: "",	        //救援公司id
				}
			},
			// 消息弹出框相关
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#district-spread-list',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#district-spread-list',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	}
		}
	}
</script>
<style scoped>
    table {
        border-collapse: collapse;
        border-spacing: 0px;
        width: 100%;
        border: #DCDCDC solid 1px;
    }
    table th {
        border-right: 1px solid #DCDCDC;
    }
    table td {
        border-bottom: 1px solid #DCDCDC;
        border-right: 1px solid #DCDCDC;
    }
    .t_left {
        width: 10%;
        height: auto;
        float: left;
      /*  border-top: 1px solid #000;
        border-left: 1px solid #000;*/
    }
    .t_right {
        width: 20%;
        height: auto;
        float: left;
       /* border-top: 1px solid #000;
        border-left: 1px solid #000;*/
    }
    /*t_r_content和cl_freeze高度相差20px， 高度为外观显示高度，可根据情况调整*/

    .t_r_content {
        width: 100%;
        height: 100%;
        background: #fff;
        overflow: auto;
    }
    .t_r_contents {
        width: 100%;
        height: 100%;
        background: #fff;
        overflow: auto;
    }
    .cl_freeze {
        height: 100%;
        overflow: hidden;
        width: 100%;
    }
    /* width 调整左边标题列宽度（左侧外观显示宽度）; 指定为width:auto 在Opera下显示有问题; height比 t_r_content 高度小20px*/
    /* width 宽度为 右侧外观显示宽度 实际显示宽度大小为“t_r”宽度加上“cl_freeze”宽度 */
    /* 如果显示不正常，调整 t_r的width 使其和t_left的width之和小于100%；等于100%时会有问题*/

    .t_r {
        width: 70%;
        height: auto;
        float: left;
      /*  border-top: 1px solid #000;
        border-right: #000 solid 1px;*/
    }
    .t_r_total {
        width: 20%;
        height: auto;
        float: left;
      /*  border-top: 1px solid #000;
        border-right: #000 solid 1px;*/
    }

    .t_r table {
        width: 100%;

    }
     .t_r_total table {
        width: 100%;
        min-width: 300px;
    }

    .t_r_title {
        width: 1720px;
    }
    /*宽度比 t_r table 大20px （至少大20，小了滚动条滑到右侧显示有问题）*/

    .t_r_t {
        width: 100%;
        overflow: hidden;
    }

    .bordertop {
        border-top: 0px;
    }

	.menuInputBrand{
		position:relative;
	}
	.menuContent{
		position:absolute;
		top:31px;
		left:6px;
		border:1px solid #ddd;
		z-index:999;
		width:calc(100% - 10px);
	}
</style>



// WEBPACK FOOTER //
// PageDistrictSpreadList.vue?4ad641be